// Other Filter Spare Parts Products Data
export const otherSparePartsProducts = {
  'plastic-tube-type-flow-meter-lzss': {
    id: 'plastic-tube-type-flow-meter-lzss',
    title: 'Plastic Tube Type Flow Meter LZSS',
    name: 'Plastic Tube Type Flow Meter LZSS',
    category: 'Other Filter Spare Parts',
    image: 'https://cdn1.sharemyimage.com/smi/2026/01/10/49122b9d76471b5bb394cad17b7796d5.jpg',
    shortDescription: 'Reliable plastic tube type flow meter available in long and short versions with high corrosion resistance.',
    description: 'LZSS-series plastic tube type flow meter consists two type (long tube and short tube type), the ABS plastic shell, with 30% anti acid corrosion performance, the specification and material could be customized.',
    longDescription: 'The LZSS series plastic tube type flow meter is engineered for precise liquid flow measurement in various environments. Featuring a durable ABS plastic shell and an AS taper tube, it offers 30% anti-acid corrosion performance. The system is available in both long and short tube configurations and can be customized with flange or screw thread connections. It is an ideal component for water treatment and industrial processing systems where corrosion resistance and reliability are paramount.',
    features: [
      'Consists of long tube and short tube types',
      'Durable ABS plastic shell',
      '30% anti-acid corrosion performance',
      'Customizable specifications and materials',
      'Available in flange or screw thread connection types',
      'Highly transparent AS material taper tube'
    ],
    applications: [
      'Industrial water treatment systems',
      'Chemical processing and monitoring',
      'Laboratory liquid measurement',
      'Environmental protection equipment',
      'Acid and alkali liquid flow control'
    ],
    specifications: {
      'Accuracy': '±4%',
      'Design Pressure': '≤0.6 MPa',
      'Operating Temperature': '0 ~ 60 ℃',
      'Taper Tube Material': 'AS (Acrylonitrile Styrene)',
      'Leader Material': 'SS304 Stainless Steel',
      'Shell/Joint Material': 'ABS Plastic',
      'Connection Type': 'Flange or Screw Thread'
    },
    technicalData: {
      'Technical Parameters': [
        { 'Model': 'LZSS-15', 'Nominal Dia': '15 mm', 'Measuring Range': '5-50 L/H to 100-1000 L/H', 'Type': 'Long/Short Tube', 'Accuracy': '±4%', 'Pressure': '≤0.6 MPa' },
        { 'Model': 'LZSS-20', 'Nominal Dia': '20 mm', 'Measuring Range': '10-100 L/H to 100-1000 L/H', 'Type': 'Long/Short Tube', 'Accuracy': '±4%', 'Pressure': '≤0.6 MPa' },
        { 'Model': 'LZSS-25', 'Nominal Dia': '25 mm', 'Measuring Range': '60-600 L/H to 300-3000 L/H', 'Type': 'Long/Short Tube', 'Accuracy': '±4%', 'Pressure': '≤0.6 MPa' },
        { 'Model': 'LZSS-32', 'Nominal Dia': '32 mm', 'Measuring Range': '0.4-4 T/H to 1-10 T/H', 'Type': 'Long/Short Tube', 'Accuracy': '±4%', 'Pressure': '≤0.6 MPa' },
        { 'Model': 'LZSS-40', 'Nominal Dia': '40 mm', 'Measuring Range': '0.4-4 T/H to 1.2-12 T/H', 'Type': 'Long/Short Tube', 'Accuracy': '±4%', 'Pressure': '≤0.6 MPa' },
        { 'Model': 'LZSS-50', 'Nominal Dia': '50 mm', 'Measuring Range': '0.4-4 T/H to 2-20 T/H', 'Type': 'Long/Short Tube', 'Accuracy': '±4%', 'Pressure': '≤0.6 MPa' },
        { 'Model': 'LZSS-65', 'Nominal Dia': '65 mm', 'Measuring Range': '5-25 T/H to 12-60 T/H', 'Type': 'Short Tube', 'Accuracy': '±4%', 'Pressure': '≤0.6 MPa' },
        { 'Model': 'LZSS-80', 'Nominal Dia': '80 mm', 'Measuring Range': '5-25 T/H to 12-60 T/H', 'Type': 'Short Tube', 'Accuracy': '±4%', 'Pressure': '≤0.6 MPa' },
        { 'Model': 'LZSS-100', 'Nominal Dia': '100 mm', 'Measuring Range': '8-50 T/H to 18-120 T/H', 'Type': 'Short Tube / Flange', 'Accuracy': '±4%', 'Pressure': '≤0.6 MPa' },
        { 'Model': 'LZSS-125', 'Nominal Dia': '125 mm', 'Measuring Range': '15-150 T/H to 25-200 T/H', 'Type': 'Short Tube / Flange', 'Accuracy': '±4%', 'Pressure': '≤0.6 MPa' },
        { 'Model': 'LZSS-150', 'Nominal Dia': '150 mm', 'Measuring Range': '15-150 T/H to 25-200 T/H', 'Type': 'Short Tube / Flange', 'Accuracy': '±4%', 'Pressure': '≤0.6 MPa' }
      ],
      'Dimension Table': [
        { 'Model': 'LZSS-15', 'Short L/H': '220/180', 'Short D1/D2/D3': '44/26/20', 'Long L/H': '310/280', 'Long D1/D2/D3': '44/26/20' },
        { 'Model': 'LZSS-20', 'Short L/H': '230/188', 'Short D1/D2/D3': '51/31/25', 'Long L/H': '322/293', 'Long D1/D2/D3': '51/31/25' },
        { 'Model': 'LZSS-25', 'Short L/H': '255/205', 'Short D1/D2/D3': '57/40/32', 'Long L/H': '345/305', 'Long D1/D2/D3': '57/40/32' },
        { 'Model': 'LZSS-32', 'Short L/H': '368/319', 'Short D1/D2/D3': '74/49/40', 'Long L/H': '390/355', 'Long D1/D2/D3': '74/49/30' },
        { 'Model': 'LZSS-40', 'Short L/H': '380/321', 'Short D1/D2/D3': '87/60/50', 'Long L/H': '410/365', 'Long D1/D2/D3': '87/60/50' },
        { 'Model': 'LZSS-50', 'Short L/H': '395/325', 'Short D1/D2/D3': '98/73/68', 'Long L/H': '430/380', 'Long D1/D2/D3': '98/73/63' },
        { 'Model': 'LZSS-65', 'Short L/H': '446/360', 'Short D1/D2/D3': '123/82/75', 'Long L/H': '—', 'Long D1/D2/D3': '—' },
        { 'Model': 'LZSS-80', 'Short L/H': '540/189', 'Short D1/D2': '189/Φ17*8', 'Long L/H': 'Flange', 'Long D1/D2/D3': '—' },
        { 'Model': 'LZSS-100', 'Short L/H': '555/189', 'Short D1/D2': '189/Φ17*8', 'Long L/H': 'Flange', 'Long D1/D2/D3': '—' }
      ]
    }
  },
  'tube-type-flow-meter-lzs': {
    id: 'tube-type-flow-meter-lzs',
    title: 'Tube Type Flow Meter LZS',
    name: 'Tube Type Flow Meter LZS',
    category: 'Other Filter Spare Parts',
    image: 'https://cdn1.sharemyimage.com/smi/2026/01/10/d9e07b36357c1feedd6ced8d141665e8.jpg',
    shortDescription: 'LZS-series tube type flow meter: inline series connection, various shapes, male/female thread options, customizable specifications and materials.',
    description: 'LZS-series flow meter can be directly series connected into the pipeline and its water inlet and outlet are separately located at the upward and downward end of the flow meter. The shape can be round, square or other polygon (round shape is commonly used). The fitting screw thread could be male thread or female thread. The specification and material could be customized.',
    longDescription: 'LZS-series tube type flow meter is a versatile inline flow indicator suitable for liquids and gases in pipelines. It supports direct series connection, multiple fitting thread options (male/female), and customizable materials and specifications. Commonly used for water treatment, chemical dosing, laboratories and other fluid control systems where compact inline measurement is required. ',
    features: [
      'Direct series connection into pipeline',
      'Inlet and outlet located on opposite ends (upward/downward)',
      'Available in round, square or other polygon shapes (round commonly used)',
      'Fitting screw thread can be male or female',
      'Customizable specifications and materials'
    ],
    applications: [
      'Industrial water treatment',
      'Chemical processing and monitoring',
      'Laboratory fluid measurement',
      'Dosing and control systems',
      'Environmental protection equipment'
    ],
    specifications: {
      'Accuracy': '±4%',
      'Working Pressure': '≤1 MPa',
      'Operating Temperature': '0 ~ 60 ℃',
      'Connection': 'Male or Female Screw Thread (various sizes)',
      'Customization': 'Specifications and materials can be customized'
    },
    technicalData: {
      'Technical Parameters': [
        { 'Model': 'LZS-0.6', 'Liquid (GPM)': '0.1–0.6', 'Liquid (LPM)': '0.5–2.5', 'Gas (Nm³/h)': '0.8–8', 'Male Thread': '', 'Female Thread': '' },
        { 'Model': 'LZS-1', 'Liquid (GPM)': '0.1–1.0', 'Liquid (LPM)': '0.5–4', 'Gas (Nm³/h)': '1–10', 'Male Thread': '', 'Female Thread': '' },
        { 'Model': 'LZS-1.5', 'Liquid (GPM)': '0.1–1.5', 'Liquid (LPM)': '0.5–5.5', 'Gas (Nm³/h)': '1.6–16', 'Male Thread': 'G 1/2\" / 1/2\" BSP', 'Female Thread': 'G 1/2\" / 1/2\" BSP' },
        { 'Model': 'LZS-2', 'Liquid (GPM)': '0.2–2.0', 'Liquid (LPM)': '1–8', 'Gas (Nm³/h)': '2.5–25', 'Male Thread': '1/2\" BSP', 'Female Thread': '1/2\" BSP' },
        { 'Model': 'LZS-2.4', 'Liquid (GPM)': '0.2–2.4', 'Liquid (LPM)': '1–9', 'Gas (Nm³/h)': '4–40', 'Male Thread': '', 'Female Thread': '' },
        { 'Model': 'LZS-5', 'Liquid (GPM)': '0.5–5', 'Liquid (LPM)': '1.8–18', 'Gas (Nm³/h)': '4–40', 'Male Thread': '', 'Female Thread': '' },
        { 'Model': 'LZS-5 (alt)', 'Liquid (GPM)': '1–5', 'Liquid (LPM)': '5–18', 'Gas (Nm³/h)': '6–60', 'Male Thread': 'G 1-1/4\" / 1-1/4\" BSP', 'Female Thread': 'G 3/4\" / 3/4\" BSP' },
        { 'Model': 'LZS-10', 'Liquid (GPM)': '2–10', 'Liquid (LPM)': '4–40', 'Gas (Nm³/h)': '6–60', 'Male Thread': '', 'Female Thread': '' },
        { 'Model': 'LZS-20', 'Liquid (GPM)': '4–20', 'Liquid (LPM)': '20–70', 'Gas (Nm³/h)': '10–1000', 'Male Thread': '', 'Female Thread': '' },
        { 'Model': 'LZS-30', 'Liquid (GPM)': '5–30', 'Liquid (LPM)': '20–110', 'Gas (Nm³/h)': '15–140', 'Male Thread': 'G 1-1/2\" / 1-1/2\" BSP', 'Female Thread': 'G 1\" / 1\" BSP' },
        { 'Model': 'LZS-40', 'Liquid (GPM)': '5–40', 'Liquid (LPM)': '5–150', 'Gas (Nm³/h)': '25–250', 'Male Thread': '', 'Female Thread': '' },
        { 'Model': 'LZS-60', 'Liquid (GPM)': '20–60', 'Liquid (LPM)': '80–225', 'Gas (Nm³/h)': '35–350', 'Male Thread': '', 'Female Thread': '' },
        { 'Model': 'LZS-80', 'Liquid (GPM)': '20–80', 'Liquid (LPM)': '100–300', 'Gas (Nm³/h)': '', 'Male Thread': '', 'Female Thread': '' },
        { 'Model': 'LZS-100', 'Liquid (GPM)': '20–100', 'Liquid (LPM)': '100–350', 'Gas (Nm³/h)': '100–500', 'Male Thread': '', 'Female Thread': '' },
        { 'Model': 'LZS-120', 'Liquid (GPM)': '20–120', 'Liquid (LPM)': '100–450', 'Gas (Nm³/h)': '300–800', 'Male Thread': 'G 2\" / 2\" BSP', 'Female Thread': 'G 2\" / 2\" BSP' },
        { 'Model': 'LZS-150', 'Liquid (GPM)': '50–150', 'Liquid (LPM)': '200–560', 'Gas (Nm³/h)': '400–1200', 'Male Thread': '', 'Female Thread': '' },
        { 'Model': 'LZS-200', 'Liquid (GPM)': '60–200', 'Liquid (LPM)': '200–800', 'Gas (Nm³/h)': '', 'Male Thread': '', 'Female Thread': '' }
      ],
      'Dimension Table': [
        { 'Model': 'LZS-(0.6-5)', 'A (mm)': '233', 'B (mm)': '178', 'C': 'Φ32', 'D (mm)': '235' },
        { 'Model': 'LZS-(5-10)', 'A (mm)': '283.5', 'B (mm)': '236.5', 'C': 'Φ45', 'D (mm)': '330' },
        { 'Model': 'LZS-(20-60)', 'A (mm)': '297', 'B (mm)': '233.5', 'C': 'Φ51', 'D (mm)': '318' },
        { 'Model': 'LZS-(80-200)', 'A (mm)': '367', 'B (mm)': '296', 'C': 'Φ75', 'D (mm)': '400' }
      ],
      'Material & Code': [
        {
          'Fitting': 'ABS, PP, PVC, Brass, Brass Chromeplate, SS',
          'Float': 'SS, Acrylic, Agate Ball, PTFE',
          'O‑Ring': 'Silicon Rubber, Fluorin Rubber'
        }
      ],
      'Notes': [
        {
          'Note': 'Table blanks indicate items not listed or not applicable. Accuracy: ±4%. Working Pressure: ≤1MPa. Operating Temperature: 0~60 ℃. Customized specifications are available.'
        }
      ]
    }
  },
  'panel-type-flow-meter-lzm': {
    id: 'panel-type-flow-meter-lzm',
    title: 'Panel Type Flow Meter LZM',
    name: 'Panel Type Flow Meter LZM',
    category: 'Other Filter Spare Parts',
    image: 'https://cdn1.sharemyimage.com/smi/2026/01/10/dd43bc58d5d2269d25f134fddff21083.jpg',
    shortDescription: 'Features of LZM-series panel type flow meter. Usually installed on control panel; inlet/outlet gaps are on the back. Before installation, set connecting mouths and fix the screw hole.',
    description: 'LZM-series panel type flow meter is usually installed on the control panel. Its water inlet and outlet gaps are both on the back, so before installation clients should set the connecting mouth for water inlet and outlet and fix the screw hole.',
    longDescription: 'LZM-series panel type flow meter is designed for panel mounting to provide compact, accurate flow indication for liquids and gases. Typical applications include instrumentation panels, control cabinets and equipment enclosures. ',
    features: [
      'Panel-mounted (control panel) installation',
      'Inlet and outlet on the back (prepare connecting mouths before installation)',
      'Compact outline sizes for different model groups',
      'Multiple screw thread options for connections',
      'Accuracy typically ±4%'
    ],
    applications: [
      'Control panels and instrumentation cabinets',
      'Water treatment dosing panels',
      'Laboratory and bench panels',
      'Process control systems',
      'OEM equipment with panel-mounted flow indication'
    ],
    specifications: {
      'Accuracy': '±4%',
      'Working Pressure': '≤1.5 MPa',
      'Operating Temperature': '0 ~ 60 ℃',
      'Mounting': 'Panel mount (fixing screw; prepare inlet/outlet at panel rear)',
      'Customization': 'Specifications and materials can be customized'
    },
    technicalData: {
      'Technical Parameters': [
        { 'Model': 'LZM-0.5', 'Liquid (GPM)': '0.1–0.5', 'Liquid (LPM)': '0.1–2', 'Gas (Nm³/h)': '0.1–1', 'Screw Thread': '', 'Accuracy': '' },
        { 'Model': 'LZM-1', 'Liquid (GPM)': '0.2–1', 'Liquid (LPM)': '1–4', 'Gas (Nm³/h)': '0.25–2.5', 'Screw Thread': 'ZG 1/2\" (1/2\" BSPT)', 'Accuracy': '' },
        { 'Model': 'LZM-2', 'Liquid (GPM)': '0.2–2', 'Liquid (LPM)': '1–7', 'Gas (Nm³/h)': '0.3–3', 'Screw Thread': 'ZG 1/4\" (1/4\" BSPT)', 'Accuracy': '' },
        { 'Model': 'LZM-3', 'Liquid (GPM)': '0.3–3', 'Liquid (LPM)': '1–11', 'Gas (Nm³/h)': '0.6–6', 'Screw Thread': '', 'Accuracy': '' },
        { 'Model': 'LZM-5', 'Liquid (GPM)': '0.5–5', 'Liquid (LPM)': '2–18', 'Gas (Nm³/h)': '1.2–12', 'Screw Thread': '', 'Accuracy': '' },
        { 'Model': 'LZM-10', 'Liquid (GPM)': '1–10', 'Liquid (LPM)': '5–35', 'Gas (Nm³/h)': '2.5–25', 'Screw Thread': '', 'Accuracy': '±4%' },
        { 'Model': 'LZM-15', 'Liquid (GPM)': '2–15', 'Liquid (LPM)': '10–60', 'Gas (Nm³/h)': '6–60', 'Screw Thread': '', 'Accuracy': '±4%' },
        { 'Model': 'LZM-20', 'Liquid (GPM)': '2–20', 'Liquid (LPM)': '10–70', 'Gas (Nm³/h)': '10–100', 'Screw Thread': 'ZG 1\" (1\" BSPT)', 'Accuracy': '±4%' },
        { 'Model': 'LZM-30', 'Liquid (GPM)': '5–30', 'Liquid (LPM)': '20–110', 'Gas (Nm³/h)': '16–160', 'Screw Thread': '', 'Accuracy': '±4%' },
        { 'Model': 'LZM-35', 'Liquid (GPM)': '15–35', 'Liquid (LPM)': '10–150', 'Gas (Nm³/h)': '30–300', 'Screw Thread': '', 'Accuracy': '±4%' },
        { 'Model': 'LZM-40', 'Liquid (GPM)': '5–40', 'Liquid (LPM)': '50–130', 'Gas (Nm³/h)': '25–250', 'Screw Thread': '', 'Accuracy': '±4%' },
        { 'Model': 'LZM-50', 'Liquid (GPM)': '10–50', 'Liquid (LPM)': '50–190', 'Gas (Nm³/h)': '', 'Screw Thread': '', 'Accuracy': '±4%' },
        { 'Model': 'LZM-60', 'Liquid (GPM)': '10–60', 'Liquid (LPM)': '20–220', 'Gas (Nm³/h)': '', 'Screw Thread': '', 'Accuracy': '±4%' },
        { 'Model': 'LZM-80', 'Liquid (GPM)': '20–80', 'Liquid (LPM)': '90–300', 'Gas (Nm³/h)': '', 'Screw Thread': 'ZG 2\" (2\" BSPT)', 'Accuracy': '±4%' },
        { 'Model': 'LZM-100', 'Liquid (GPM)': '25–100', 'Liquid (LPM)': '100–350', 'Gas (Nm³/h)': '', 'Screw Thread': '', 'Accuracy': '±4%' },
        { 'Model': 'LZM-150', 'Liquid (GPM)': '30–150', 'Liquid (LPM)': '100–550', 'Gas (Nm³/h)': '', 'Screw Thread': '', 'Accuracy': '±4%' }
      ],
      'Outline Size (mm)': [
        { 'Model': 'LZM-(0.5-5)', 'A (mm)': '176.5', 'B (mm)': '31', 'C': '171', 'D (mm)': '34', 'E (mm)': '26.5', 'F (mm)': '76', 'G (mm)': '127', 'H (mm)': '26' },
        { 'Model': 'LZM-(10-35)', 'A (mm)': '232', 'B (mm)': '44', 'C': '225', 'D (mm)': '45', 'E (mm)': '33', 'F (mm)': '100', 'G (mm)': '160.5', 'H (mm)': '35.5' },
        { 'Model': 'LZM-(50-150)', 'A (mm)': '296', 'B (mm)': '70', 'C': '281', 'D (mm)': '82.5', 'E (mm)': '50', 'F (mm)': '100', 'G (mm)': '189.5', 'H (mm)': '62.5' }
      ],
      'Material & Code': [
        { 'W/T Value': '>W-Width', 'Value': 'Brass', 'Fitting': 'ABS, PP, PVC, Brass, Brass Chromeplate, SS', 'Float': 'SS, Acrylic, Agate ball, PTFE', 'O-ring': 'Silicon Rubber, Fluorin Rubber' },
        { 'W/T Value': '>T-Without', 'Value': 'SS', 'Fitting': 'ABS, PP, PVC, Brass, Brass Chromeplate, SS', 'Float': 'SS, Acrylic, Agate ball, PTFE', 'O-ring': 'Silicon Rubber, Fluorin Rubber' }
      ],
      'Notes': [
        { 'Note': 'The fixed screw of center distance F is M6×11.' },
        { 'Note': 'Working Pressure: ≤1.5MPa.' },
        { 'Note': 'Operating Temperature: 0~60 ℃.' },
        { 'Note': 'Customized specifications are available.' }
      ]
    }
  },
  'solenoid-valve': {
    id: 'solenoid-valve',
    title: 'Solenoid Valve',
    name: 'Solenoid Valve',
    category: 'Other Filter Spare Parts',
    image: 'https://cdn1.sharemyimage.com/smi/2026/01/10/d18fdd2adca6c1b2d61fbf4c8dd4803b.jpg',
    shortDescription: 'High-quality 2W series solenoid valves available in brass and stainless steel for various fluid control applications.',
    description: '2W series solenoid valve with direct-acting, diaphragm structure. Available in normal close/open types, suitable for air, water, oil, and gas.',
    longDescription: 'The 2W series solenoid valve is a reliable fluid control component used in various industrial and water treatment applications. It features a direct-acting or pilot-operated diaphragm structure, capable of starting at zero pressure differential. Available in Stainless Steel 304 or Brass body materials, with a wide range of sizes from 1/4" to 2". It supports multiple voltage options (AC220V, AC110V, DC24V, DC12V) and is suitable for working with air, water, oil, and gas media.',
    features: [
      'Direct-acting, diaphragm structure, capable of zero pressure start',
      'Body Material: available in Brass and Stainless Steel 304',
      'Wide size range: 1/4" to 2" (DN08 to DN50)',
      'Working Pressure: 0-1.0 Mpa',
      'Operating Temperature: -5 ~ 80°C',
      'Voltage options: AC220V, AC110V, DC24V, DC12V',
      'Protection Class: IP65',
      'Seal Material: NBR, EPDM, VITON (Standard: NBR)'
    ],
    applications: [
      'Water treatment systems',
      'Industrial automation control',
      'Air and gas pipelines',
      'Oil fluid control',
      'General fluid control applications'
    ],
    specifications: {
      'Body Material': 'Brass, Stainless Steel 304',
      'Seal Material': 'NBR (Standard), EPDM, VITON',
      'Connection': 'Female Thread (G/NPT)',
      'Orifice Size': 'DN08 - DN50',
      'Working Pressure': '0 - 1.0 MPa (0 - 10 Bar)',
      'Max Pressure Resistance': '1.0 MPa',
      'Fluid Temperature': '-5 ~ 80 °C',
      'Voltage': 'AC220V, AC110V, DC24V, DC12V'
    },
    technicalData: {
      '2W-DNxx-A Series (Normal Close)': [
        { 'Model': '2W-DN08-A', 'Body material': 'SS304 / Brass', 'In/out port': '1/4" female', 'Operating type': 'Normal close', 'Rating voltage': 'AC220V / AC110V / DC24V / DC12V', 'Working pressure': '0-1.0Mpa', 'Temperature': '0 ~ 80°C' },
        { 'Model': '2W-DN10-A', 'Body material': 'SS304 / Brass', 'In/out port': '3/8" female', 'Operating type': 'Normal close', 'Rating voltage': 'AC220V / AC110V / DC24V / DC12V', 'Working pressure': '0-1.0Mpa', 'Temperature': '0 ~ 80°C' },
        { 'Model': '2W-DN15-A', 'Body material': 'SS304 / Brass', 'In/out port': '1/2" female', 'Operating type': 'Normal close', 'Rating voltage': 'AC220V / AC110V / DC24V / DC12V', 'Working pressure': '0-1.0Mpa', 'Temperature': '0 ~ 80°C' },
        { 'Model': '2W-DN20-A', 'Body material': 'SS304 / Brass', 'In/out port': '3/4" female', 'Operating type': 'Normal close', 'Rating voltage': 'AC220V / AC110V / DC24V / DC12V', 'Working pressure': '0-1.0Mpa', 'Temperature': '0 ~ 80°C' },
        { 'Model': '2W-DN25-A', 'Body material': 'SS304 / Brass', 'In/out port': '1" female', 'Operating type': 'Normal close', 'Rating voltage': 'AC220V / AC110V / DC24V / DC12V', 'Working pressure': '0-1.0Mpa', 'Temperature': '0 ~ 80°C' },
        { 'Model': '2W-DN32-A', 'Body material': 'SS304 / Brass', 'In/out port': '1 1/4" female', 'Operating type': 'Normal close', 'Rating voltage': 'AC220V / AC110V / DC24V / DC12V', 'Working pressure': '0-1.0Mpa', 'Temperature': '0 ~ 80°C' },
        { 'Model': '2W-DN40-A', 'Body material': 'SS304 / Brass', 'In/out port': '1 1/2" female', 'Operating type': 'Normal close', 'Rating voltage': 'AC220V / AC110V / DC24V / DC12V', 'Working pressure': '0-1.0Mpa', 'Temperature': '0 ~ 80°C' },
        { 'Model': '2W-DN50-A', 'Body material': 'SS304 / Brass', 'In/out port': '2" female', 'Operating type': 'Normal close', 'Rating voltage': 'AC220V / AC110V / DC24V / DC12V', 'Working pressure': '0-1.0Mpa', 'Temperature': '0 ~ 80°C' }
      ],
      '2W-DNxx-B Series (Normal Close / Normal Open)': [
        { 'Model': '2W-DN15-B', 'Body material': 'SS304 / Brass', 'In/out port': '1/2" female', 'Operating type': 'Normal close / Normal open', 'Rating voltage': 'AC220V / AC110V / DC24V / DC12V', 'Working pressure': '0-1.0Mpa', 'Temperature': '0 ~ 80°C' },
        { 'Model': '2W-DN20-B', 'Body material': 'SS304 / Brass', 'In/out port': '3/4" female', 'Operating type': 'Normal close / Normal open', 'Rating voltage': 'AC220V / AC110V / DC24V / DC12V', 'Working pressure': '0-1.0Mpa', 'Temperature': '0 ~ 80°C' },
        { 'Model': '2W-DN25-B', 'Body material': 'SS304 / Brass', 'In/out port': '1" female', 'Operating type': 'Normal close / Normal open', 'Rating voltage': 'AC220V / AC110V / DC24V / DC12V', 'Working pressure': '0-1.0Mpa', 'Temperature': '0 ~ 80°C' },
        { 'Model': '2W-DN32-B', 'Body material': 'SS304 / Brass', 'In/out port': '1 1/4" female', 'Operating type': 'Normal close / Normal open', 'Rating voltage': 'AC220V / AC110V / DC24V / DC12V', 'Working pressure': '0-1.0Mpa', 'Temperature': '0 ~ 80°C' },
        { 'Model': '2W-DN40-B', 'Body material': 'SS304 / Brass', 'In/out port': '1 1/2" female', 'Operating type': 'Normal close / Normal open', 'Rating voltage': 'AC220V / AC110V / DC24V / DC12V', 'Working pressure': '0-1.0Mpa', 'Temperature': '0 ~ 80°C' },
        { 'Model': '2W-DN50-B', 'Body material': 'SS304 / Brass', 'In/out port': '2" female', 'Operating type': 'Normal close / Normal open', 'Rating voltage': 'AC220V / AC110V / DC24V / DC12V', 'Working pressure': '0-1.0Mpa', 'Temperature': '0 ~ 80°C' }
      ]
    }
  },
  'ro-controller-ro-2003': {
    id: 'ro-controller-ro-2003',
    title: 'RO Controller RO-2003',
    name: 'RO Controller RO-2003',
    category: 'Other Filter Spare Parts',
    image: 'https://cdn1.sharemyimage.com/smi/2026/01/10/448f72ba5c6faa72fd93126eb666cc72.jpg',
    shortDescription: 'Model: RO-2003. Professional Reverse Osmosis Process Controller.',
    description: 'RO-2003 is a general-purpose controller for small and medium-scale reverse osmosis systems, combining control functions with on-line conductivity monitoring.',
    longDescription: 'The RO-2003 Reverse Osmosis Controller is designed for the automatic operation and monitoring of RO water treatment systems. It integrates PLC control logic with conductivity measurement, providing a complete solution for managing feed pumps, high-pressure pumps, inlet valves, and flush valves. The front panel features a clear process flow diagram with LED indicators showing the current system status (Power, Low Feed Press, Low Press, High Press, RO, Full, etc.). It ensures the safe and efficient operation of the RO system by monitoring water levels, pressure status, and water quality.',
    features: [
      'Combined automatic control and on-line conductivity monitoring',
      'LED process flow diagram display for intuitive status monitoring',
      'Automatic control of Feed Pump, High Pressure Pump, Inlet Valve, and Flush Valve',
      'Protection functions: Low feed pressure, High pressure protection, Tank full stop',
      'Automatic flush cycle control',
      'Compact panel-mount design'
    ],
    applications: [
      'Small to medium industrial RO systems',
      'Commercial water purification systems',
      'Medical water treatment',
      'Electronic industry water supply',
      'Food and beverage water treatment'
    ],
    specifications: {
      'Model': 'RO-2003',
      'Power Supply': 'AC 220V ±15% 50Hz',
      'Power Consumption': '≤ 3W',
      'Control Output': 'Relay output (ON/OFF)',
      'Contact Capacity': 'AC 250V / 5A (resistive load)',
      'Conductivity Range': '0 ~ 20 / 0 ~ 200 μS/cm (Switchable)',
      'Accuracy': '1.5% (FS)',
      'Display': 'LED / Analog Meter (depending on specific sub-version)',
      'Dimensions': '96 × 48 × 100 mm (approx. standard size)',
      'Cut-out Size': '92 × 45 mm'
    },
    technicalData: {
      'Terminal Connections': [
        { 'Terminal': '1, 2', 'Function': 'Power Supply AC 220V' },
        { 'Terminal': '3, 4', 'Function': 'Feed Pump (Contactor Coil)' },
        { 'Terminal': '5, 6', 'Function': 'High Pressure Pump (Contactor Coil)' },
        { 'Terminal': '7, 8', 'Function': 'Inlet Valve' },
        { 'Terminal': '9, 10', 'Function': 'Flush Valve' },
        { 'Terminal': '11, 12', 'Function': 'Conductivity Cell Input' }
      ]
    }
  },
  'cnp-pump': {
    id: 'cnp-pump',
    title: 'CNP Multistage Centrifugal Pump',
    name: 'CNP Multistage Centrifugal Pump',
    category: 'Other Filter Spare Parts',
    image: 'https://cdn1.sharemyimage.com/smi/2026/01/10/4fb4c707ffef9ea2fd2e1185e3225f1a.jpg',
    shortDescription: 'CDL/CDLF Series vertical non-self priming multistage centrifugal pump.',
    description: 'High-performance non-self priming multistage centrifugal pumps available in vertical (CDL/CDLF) and horizontal (CHL/CHLF) configurations.',
    longDescription: 'CNP offers professional pumping solutions for water treatment. The CDL/CDLF Series are vertical non-self priming multistage centrifugal pumps driven by a standard electric motor. The motor output shaft directly connects with the pump shaft through a coupling. The CHL/CHLF Series are horizontal non-self priming multistage centrifugal pumps, ideal for compact installations. Both series are designed for durability, high efficiency, and reliable operation in demanding environments.',
    features: [
      'Vertical (CDL/CDLF) and Horizontal (CHL/CHLF) options',
      'Non-self priming multistage centrifugal design',
      'High efficiency and energy-saving performance',
      'Standard electric motor drive (IP55, Class F)',
      'Compact structure for easy integration',
      'Reliable mechanical seal for leak protection'
    ],
    applications: [
      'Water supply and pressure boosting',
      'Industrial liquid conveying',
      'Water treatment and filtration systems',
      'Boiler feed and condensate systems',
      'Irrigation and dewatering',
      'Cooling and air-conditioning systems'
    ],
    specifications: {
      'Type': 'Multistage Centrifugal Pump',
      'Orientation': 'Vertical / Horizontal',
      'Priming': 'Non-self priming',
      'Fluid Temperature': '-15°C to +120°C',
      'Motor Protection': 'IP55',
      'Insulation Class': 'Class F',
      'Max Operating Pressure': 'Up to 25 bar (model dependent)'
    },
    technicalData: {
      'Series Overview': [
        { 'Series': 'CDL/CDLF', 'Type': 'Vertical', 'Description': 'Vertical non-self priming multistage centrifugal pump' },
        { 'Series': 'CHL/CHLF', 'Type': 'Horizontal', 'Description': 'Horizontal non-self priming multistage centrifugal pump' }
      ],
      'Detail View': [
        { 'Info': 'Technical drawing and series comparison', 'Reference': 'https://cdn1.sharemyimage.com/smi/2026/01/10/0def0fb937daca0776921e77d28bbdb3.jpg' }
      ]
    }
  },
  'pressure-gauge': {
    id: 'pressure-gauge',
    title: 'Pressure Gauge',
    name: 'Pressure Gauge',
    category: 'Other Filter Spare Parts',
    image: 'https://cdn1.sharemyimage.com/smi/2026/01/10/57bac2ad6eee7941bee4cac472a7f637.jpg',
    shortDescription: 'Minipore pressure gauge consists two type (with liquid filled and without liquid filled); The liquid filled pressure gauge is shock resistant besides other qualities and can be used to measure the positive and negative pressure under the circumstance of mechanic vibration and pressure with impulse; Measure Range::0~15Psi...0~8500Psi( with Bar or MPa printed); The materials and specifications could be customized as clients\' requirements.',
    description: 'Minipore pressure gauge consists two type (with liquid filled and without liquid filled). The liquid filled pressure gauge is shock resistant and suitable for measuring positive and negative pressure under mechanic vibration and impulse conditions.',
    longDescription: 'Minipore pressure gauges are available in two main types: liquid-filled and dry (without liquid). The liquid-filled models offer superior shock resistance and are ideal for measuring positive and negative pressure in environments subject to mechanical vibration and pressure impulses. They feature a wide measurement range from 0-15 Psi up to 0-8500 Psi, with scales printed in Bar or MPa. Materials and specifications can be fully customized to meet client requirements.',
    features: [
      'Available in liquid-filled (shock resistant) and dry types',
      'Measures positive and negative pressure',
      'Suitable for environments with mechanical vibration and impulse',
      'Measurement Range: 0~15 Psi to 0~8500 Psi',
      'Scales available in Psi, Bar, or MPa',
      'Customizable materials and specifications'
    ],
    applications: [
      'Industrial machinery',
      'Pumps and compressors',
      'Hydraulic and pneumatic systems',
      'Water treatment equipment',
      'Chemical processing'
    ],
    specifications: {
      'Type': 'Liquid filled / Dry',
      'Measurement Range': '0~15 Psi ... 0~8500 Psi',
      'Units': 'Psi, Bar, MPa',
      'Case Material': 'Steel, SS304, Plastic (customizable)',
      'Connection': 'Bottom, Back, Back with border'
    },
    technicalData: {
      'Pressure Gauge Specifications': [
        { 'Diameter': '1-1/2"', 'Model': 'Y-40', 'Installation Type': 'Bottom Connection', 'Measure Range': '0~15 Psi ... 0~3500Psi', 'Screw Thread': '1/8" NPT, BSPT, BSP, M10*1', 'Case Material': 'Steel, SS304, Plastic', 'Accuracy': '±2.5%' },
        { 'Diameter': '1-1/2"', 'Model': 'Y-40Z', 'Installation Type': 'Back Connection', 'Measure Range': '...', 'Screw Thread': '...', 'Case Material': '...', 'Accuracy': '...' },
        { 'Diameter': '1-1/2"', 'Model': 'Y-40ZT', 'Installation Type': 'Back Connection with border', 'Measure Range': '...', 'Screw Thread': '...', 'Case Material': '...', 'Accuracy': '...' },
        { 'Diameter': '2"', 'Model': 'Y-50', 'Installation Type': 'Bottom Connection', 'Measure Range': '0~15 Psi ... 0~3500Psi', 'Screw Thread': '1/8", 1/4" NPT, BSPT, BSP, M14*1.5', 'Case Material': 'Steel, SS304, Plastic', 'Accuracy': '±2.5%' },
        { 'Diameter': '2"', 'Model': 'Y-50Z', 'Installation Type': 'Back Connection', 'Measure Range': '...', 'Screw Thread': '...', 'Case Material': '...', 'Accuracy': '...' },
        { 'Diameter': '2"', 'Model': 'Y-50ZT', 'Installation Type': 'Back Connection with border', 'Measure Range': '...', 'Screw Thread': '...', 'Case Material': '...', 'Accuracy': '...' },
        { 'Diameter': '2-1/2"', 'Model': 'Y-60', 'Installation Type': 'Bottom Connection', 'Measure Range': '0~15 Psi ... 0~6000Psi', 'Screw Thread': '1/8", 1/4" NPT, BSPT, BSP M14*1.5', 'Case Material': 'Steel, SS304, Plastic', 'Accuracy': '±2.5%' },
        { 'Diameter': '2-1/2"', 'Model': 'Y-60Z', 'Installation Type': 'Back Connection', 'Measure Range': '...', 'Screw Thread': '...', 'Case Material': '...', 'Accuracy': '...' },
        { 'Diameter': '2-1/2"', 'Model': 'Y-60ZT', 'Installation Type': 'Back Connection with border', 'Measure Range': '...', 'Screw Thread': '...', 'Case Material': '...', 'Accuracy': '...' },
        { 'Diameter': '3"', 'Model': 'Y-75', 'Installation Type': 'Bottom Connection', 'Measure Range': '0-15Psi ... 0-6000Psi', 'Screw Thread': '1/4", 3/8" NPT, BSPT, BSP M14*1.5', 'Case Material': 'Steel, SS304, Plastic', 'Accuracy': '±2.5%' },
        { 'Diameter': '3"', 'Model': 'Y-75Z', 'Installation Type': 'Back Connection', 'Measure Range': '...', 'Screw Thread': '...', 'Case Material': '...', 'Accuracy': '...' },
        { 'Diameter': '3"', 'Model': 'Y-75ZT', 'Installation Type': 'Back Connection with border', 'Measure Range': '...', 'Screw Thread': '...', 'Case Material': '...', 'Accuracy': '...' },
        { 'Diameter': '4"', 'Model': 'Y-100', 'Installation Type': 'Bottom Connection', 'Measure Range': '0~15 Psi ... 0~8500Psi', 'Screw Thread': '3/8", 1/2" NPT, BSPT, BSP M20*1.5', 'Case Material': 'Steel, SS304, Plastic', 'Accuracy': '±1.6%' },
        { 'Diameter': '4"', 'Model': 'Y-100Z', 'Installation Type': 'Back Connection', 'Measure Range': '...', 'Screw Thread': '...', 'Case Material': '...', 'Accuracy': '...' },
        { 'Diameter': '4"', 'Model': 'Y-100ZT', 'Installation Type': 'Back Connection with border', 'Measure Range': '...', 'Screw Thread': '...', 'Case Material': '...', 'Accuracy': '...' },
        { 'Diameter': '6"', 'Model': 'Y-150', 'Installation Type': 'Bottom Connection', 'Measure Range': '0~15 Psi ... 0~8500Psi', 'Screw Thread': '3/8", 1/2" NPT, BSPT, BSP M20*1.5', 'Case Material': 'Steel, SS304, Plastic', 'Accuracy': '±2.5%' },
        { 'Diameter': '6"', 'Model': 'Y-150Z', 'Installation Type': 'Back Connection', 'Measure Range': '...', 'Screw Thread': '...', 'Case Material': '...', 'Accuracy': '...' },
        { 'Diameter': '6"', 'Model': 'Y-150ZT', 'Installation Type': 'Back Connection with border', 'Measure Range': '...', 'Screw Thread': '...', 'Case Material': '...', 'Accuracy': '...' }
      ]
    }
  },
  'pressure-controller': {
    id: 'pressure-controller',
    title: 'Pressure Controller',
    name: 'Pressure Controller',
    category: 'Other Filter Spare Parts',
    image: 'https://cdn1.sharemyimage.com/smi/2026/01/10/46ecd9034d42c20e0f767555b09d315d.jpg',
    shortDescription: 'Reliable pressure switches for low and high pressure control in water treatment systems.',
    description: 'Pressure controllers designed to protect pumps and systems by monitoring and controlling low and high pressure conditions.',
    longDescription: 'Our Pressure Controllers are essential safety and control devices for water treatment systems, including RO units and booster pumps. They monitor system pressure and automatically switch connected equipment (like pumps) on or off based on preset pressure thresholds. Available in Low Pressure (L.P.) protection models to prevent dry running and High Pressure (H.P.) models to prevent over-pressurization, ensuring system longevity and safety.',
    features: [
      'Available in Low Pressure (L.P.) and High Pressure (H.P.) models',
      'Adjustable pressure ranges and differential settings',
      'Automatic reset function',
      'Precise factory settings for common applications',
      'Durable construction for industrial environments',
      'Essential protection for pumps and membrane systems'
    ],
    applications: [
      'Reverse Osmosis (RO) systems',
      'Water supply systems',
      'Booster pump control',
      'Industrial process control',
      'HVAC systems'
    ],
    specifications: {
      'Type': 'Pressure Switch / Controller',
      'Media': 'Non-corrosive liquids, air',
      'Reset': 'Automatic',
      'Connection': 'Standard thread (typically 1/4" or as specified)',
      'Electrical Rating': 'Standard industrial ratings (check manual)'
    },
    technicalData: {
      'Pressure Control Specifications': [
        {
          'Type': 'Low Pressure (L.P.)',
          'Model': 'P2',
          'Low P. Adjust Range (bar)': '0-2',
          'Low P. Diff (bar)': '0.4-1',
          'Reset': 'Auto',
          'Factory Setting OFF (bar)': '1',
          'Factory Setting ON (bar)': '0.6'
        },
        {
          'Type': 'Low Pressure (L.P.)',
          'Model': 'P3',
          'Low P. Adjust Range (bar)': '-0.5-3',
          'Low P. Diff (bar)': '0.5-2',
          'Reset': 'Auto',
          'Factory Setting OFF (bar)': '1.5',
          'Factory Setting ON (bar)': '1'
        },
        {
          'Type': 'Low Pressure (L.P.)',
          'Model': 'P6',
          'Low P. Adjust Range (bar)': '-0.5-6',
          'Low P. Diff (bar)': '1-4',
          'Reset': 'Auto',
          'Factory Setting OFF (bar)': '3',
          'Factory Setting ON (bar)': '2'
        },
        {
          'Type': 'Low Pressure (L.P.)',
          'Model': 'P10',
          'Low P. Adjust Range (bar)': '1-10',
          'Low P. Diff (bar)': '1-3',
          'Reset': 'Auto',
          'Factory Setting OFF (bar)': '6',
          'Factory Setting ON (bar)': '5'
        },
        {
          'Type': 'High Pressure (H.P.)',
          'Model': 'P12D',
          'High P. Adjust Range (bar)': '5-12',
          'High P. Diff (bar)': '1-3',
          'Reset': 'Auto',
          'Factory Setting OFF (bar)': '8',
          'Factory Setting ON (bar)': '7'
        },
        {
          'Type': 'High Pressure (H.P.)',
          'Model': 'P16D',
          'High P. Adjust Range (bar)': '5-16',
          'High P. Diff (bar)': '1-3',
          'Reset': 'Auto',
          'Factory Setting OFF (bar)': '7',
          'Factory Setting ON (bar)': '5'
        },
        {
          'Type': 'High Pressure (H.P.)',
          'Model': 'P20D',
          'High P. Adjust Range (bar)': '5-20',
          'High P. Diff (bar)': '1-3',
          'Reset': 'Auto',
          'Factory Setting OFF (bar)': '12',
          'Factory Setting ON (bar)': '10.5'
        },
        {
          'Type': 'High Pressure (H.P.)',
          'Model': 'P30D',
          'High P. Adjust Range (bar)': '5-30',
          'High P. Diff (bar)': '5-10',
          'Reset': 'Auto',
          'Factory Setting OFF (bar)': '20',
          'Factory Setting ON (bar)': '15'
        }
      ]
    }
  },
  'portable-sdi-fi-pollution-index-apparatus': {
    id: 'portable-sdi-fi-pollution-index-apparatus',
    title: 'Portable SDI(FI) Pollution Index Apparatus',
    name: 'Portable SDI(FI) Pollution Index Apparatus',
    category: 'Other Filter Spare Parts',
    image: 'https://cdn1.sharemyimage.com/smi/2026/01/10/8858340123a5927d97d49907c465e36a.jpg',
    shortDescription: 'Portable apparatus for determining Silt Density Index (SDI) / Fouling Index (FI) of water, essential for RO system monitoring.',
    description: 'SPECIFICATION： φ47mm MICRON RATING: 0.45μm. The value of pollution index (SDI Apparatus), namely, Fouling Index (FI) value, is one of important parameter to the index of water quality indicating particle and colloid content.',
    longDescription: `During reverse osmosis water treatment system, the value of pollution index (SDI Apparatus) determines one of the important indexes of the water entering the reverse osmosis. It is the main means whether the entering water is up to the requirement of reverse osmosis device through examining water treatment process system in advance. The size of pollution index is crucial to life-span of reverse osmosis operation.

SDI value is determined by attenuation of water flow velocity, when water flow entering microfiltration membrane (outer dia.47mm, pore size:0.45µm). At pore size 0.45µm, colloid substances more easily occlude filter membrane than hard particles. The attenuation of water flow velocity is transformed into a numerical value between 1 and 100, namely SDI value. The smaller the SDI value, the less likely the filter membrane is polluted. Generally, the SDI value of the water entering the RO device is required to be under "5".

The SDI47 pollution index apparatus includes a pressure regulating valve, outer dia. 47mm membrane filter box, microfiltration membrane piece, and required valves/pipes. It meets ASTM method 4189-95 requirements.`,
    features: [
      'Measures Fouling Index (FI) / SDI value',
      'Includes pressure regulating valve and filter box',
      'Uses φ47mm, 0.45μm microfiltration membrane',
      'Crucial for protecting RO membranes',
      'Complies with ASTM method 4189-95',
      'Portable and easy to use on-line'
    ],
    applications: [
      'Reverse Osmosis (RO) system inlet monitoring',
      'Water quality analysis',
      'Water treatment process evaluation',
      'Determining pretreatment requirements'
    ],
    specifications: {
      'Membrane Diameter': 'φ47mm',
      'Micron Rating': '0.45μm',
      'Standard': 'ASTM D4189-95',
      'Test Pressure': '207 kPa (30 psi)',
      'Required Accessories': 'Measuring cylinder (500ml), Stopwatch (0.2s precision)',
      'Membrane Type': 'CN-CA mixed cellulose'
    },
    technicalData: {
      'Structure Components': [
        { 'Part': '(1)', 'Description': 'Connection Screw / Inlet' },
        { 'Part': '(2)', 'Description': 'Water Ball Valve' },
        { 'Part': '(3)', 'Description': 'Pressure Gauge' },
        { 'Part': '(4)', 'Description': 'Quick Connect Valve' },
        { 'Part': '(5)', 'Description': 'Locking Screw' },
        { 'Part': '(6)', 'Description': 'Top Cover' },
        { 'Part': '(7)', 'Description': 'Underpan / Support Board' },
        { 'Part': '(10)', 'Description': 'Adjusting Knob / Regulator' }
      ],
      'Operating Instructions': [
        { 'Step': '1', 'Action': 'Close water ball valve (2), connect installation screw (1) to sampling point.' },
        { 'Step': '2', 'Action': 'Open ball valve (2), pull adjusting knob (10) to set pressure to 207kpa.' },
        { 'Step': '3', 'Action': 'Close ball valve (2). Remove membrane filter box via quick connect valve (4).' },
        { 'Step': '4', 'Action': 'Place 0.45µm membrane in support board (7), assemble box with O-ring and top cover (6), tighten screw (5).' },
        { 'Step': '5', 'Action': 'Reconnect filter box. Open ball valve (2) slowly to expel air, then close and tighten screw (5) completely.' },
        { 'Step': '6', 'Action': 'Open ball valve (2). Measure time (t1) to filter 500ml water.' },
        { 'Step': '7', 'Action': 'After 5, 10, or 15 mins (Tt), measure time (t2) to filter 500ml water again.' },
        { 'Step': '8', 'Action': 'Calculate SDI. Maintain pressure at 207+/-7kpa and stable temperature throughout.' }
      ]
    }
  },
  'conductivity-meter': {
    id: 'conductivity-meter',
    title: 'Conductivity Meter',
    name: 'Conductivity Meter',
    category: 'Other Filter Spare Parts',
    image: 'https://cdn1.sharemyimage.com/smi/2026/01/10/63a7b97576951bd88c2658470d38ea9d.png',
    shortDescription: 'Model: CCT-3320V (CM230). Reliable inline conductivity monitor for water quality measurement.',
    description: 'Model CCT-3320V (CM230) is a widely used conductivity monitor for water treatment systems, featuring automatic range shift and digital temperature compensation.',
    longDescription: 'The CCT-3320V (formerly CM230) Conductivity Monitor is designed for continuous online measurement of electrical conductivity in water treatment systems. It features a highly reliable design with no internal adjustable components, utilizing programmed automatic calibration. The instrument offers automatic measurement range shifting and digital temperature compensation to ensure accurate readings across varying conditions. Ideally suited for reverse osmosis, pure water, and cooling water systems.',
    features: [
      'No adjustable internal components, ensuring higher reliability through programmed automatic calibration',
      'Automatic measurement range shift for versatility',
      'Automatic digital temperature compensation (reference 25°C)',
      'Stable performance with 1.5% (FS) accuracy',
      'Compact panel-mount design (48×96mm standard)'
    ],
    applications: [
      'Reverse Osmosis (RO) systems',
      'Pure water production',
      'Cooling water monitoring',
      'Industrial water treatment',
      'General water quality monitoring'
    ],
    specifications: {
      'Model': 'CCT-3320V (CM230)',
      'Measurement Range': '0-20, 0-200, 0-2000 μS/cm (Automatic shift)',
      'Accuracy': '1.5% (FS)',
      'Stability': '±2×10⁻³ (FS) / 24h',
      'Display': '3.5-bit LCD',
      'Power Supply': 'AC 220V ±10% 50Hz',
      'Power Consumption': '1W',
      'Dimensions': '48 × 96 × 100mm (H×W×D)',
      'Installation Cut-out': '45 × 91mm'
    },
    technicalData: {
      'Sensor / Electrode': [
        { 'Type': 'Auxiliary Electrode', 'Structure': 'Plastic', 'Constant': '1.0 cm⁻¹' },
        { 'Thread Dimension': '1/2" pipe thread', 'Medium Pressure': '0-0.5 Mpa', 'Medium Temperature': '5-50°C' },
        { 'Cable': 'Quad cable, copper mesh & foil shielded', 'Standard Length': '5m', 'Optional Length': '5-30m' },
        { 'Temp Compensation': 'NTC component', 'Method': 'Automatic (Ref 25°C)', 'Range': '5-50°C' }
      ],
      'Environmental Conditions': [
        { 'Condition': 'Temperature', 'Range': '0-50°C' },
        { 'Condition': 'Humidity', 'Range': '≤85%RH' }
      ]
    }
  }
};

export const otherSparePartsProductsList = [
  {
    id: 'plastic-tube-type-flow-meter-lzss',
    name: 'Plastic Tube Type Flow Meter LZSS',
    category: 'Other Filter Spare Parts',
    image: 'https://cdn1.sharemyimage.com/smi/2026/01/10/49122b9d76471b5bb394cad17b7796d5.jpg',
    shortDescription: 'Available in long and short tube types with 30% anti-acid corrosion performance.',
    description: 'A versatile plastic tube type flow meter featuring an ABS shell and AS taper tube for chemical resistance.',
    features: ['Long and short tube types', 'ABS plastic shell', '30% anti-acid corrosion'],
    applications: ['Water treatment', 'Chemical processing']
  },
  {
    id: 'tube-type-flow-meter-lzs',
    name: 'Tube Type Flow Meter LZS',
    category: 'Other Filter Spare Parts',
    image: 'https://cdn1.sharemyimage.com/smi/2026/01/10/d9e07b36357c1feedd6ced8d141665e8.jpg',
    shortDescription: 'LZS-series tube type flow meter: inline series connection, various shapes, male/female thread options, customizable specifications and materials.',
    description: 'LZS-series tube type flow meter suitable for inline measurement of liquids and gases; available in multiple sizes and thread options with ±4% accuracy.',
    features: ['Direct series connection into pipeline', 'Multiple shapes available (round common)', 'Male or female thread fittings', 'Customizable materials and specs'],
    applications: ['Water treatment', 'Chemical processing', 'Laboratory measurement', 'Dosing systems']
  },
  {
    id: 'panel-type-flow-meter-lzm',
    name: 'Panel Type Flow Meter LZM',
    category: 'Other Filter Spare Parts',
    image: 'https://cdn1.sharemyimage.com/smi/2026/01/10/dd43bc58d5d2269d25f134fddff21083.jpg',
    shortDescription: 'LZM-series panel type flow meter: panel-mounted, back inlet/outlet, prepare connecting mouths and fix screw hole before installation.',
    description: 'Panel-mounted flow meter for control panels and instrumentation; multiple sizes and panel outline options; working pressure ≤1.5MPa; operating temp 0~60 ℃.',
    features: ['Panel-mounted', 'Back inlet/outlet', 'Panel fixing screw required', 'Multiple connection thread options'],
    applications: ['Control panels', 'Instrumentation', 'Water treatment panels']
  },
  {
    id: 'solenoid-valve',
    name: 'Solenoid Valve',
    category: 'Other Filter Spare Parts',
    image: 'https://cdn1.sharemyimage.com/smi/2026/01/10/d18fdd2adca6c1b2d61fbf4c8dd4803b.jpg',
    shortDescription: 'High-quality 2W series solenoid valves available in brass and stainless steel for fluid control.',
    description: 'Direct-acting diaphragm solenoid valves, normally close/open types, available in sizes 1/4" to 2", suitable for air, water, oil, and gas.',
    features: ['Brass or SS304 Body', 'Zero pressure start', 'Normal Close / Normal Open', 'IP65 Protection'],
    applications: ['Water treatment', 'Industrial automation', 'Fluid control']
  },
  {
    id: 'ro-controller-ro-2003',
    name: 'RO Controller RO-2003',
    category: 'Other Filter Spare Parts',
    image: 'https://cdn1.sharemyimage.com/smi/2026/01/10/448f72ba5c6faa72fd93126eb666cc72.jpg',
    shortDescription: 'Model: RO-2003. Professional Reverse Osmosis Process Controller.',
    description: 'Automatic control unit for RO systems with integrated conductivity monitoring and process display.',
    features: ['Automatic RO process control', 'Integrated conductivity meter', 'LED status display', 'Multiple protection modes'],
    applications: ['RO System Control', 'Water Quality Monitoring']
  },
  {
    id: 'cnp-pump',
    name: 'CNP Pump',
    category: 'Other Filter Spare Parts',
    image: 'https://cdn1.sharemyimage.com/smi/2026/01/10/4fb4c707ffef9ea2fd2e1185e3225f1a.jpg',
    shortDescription: 'CDL/CDLF Series vertical non-self priming multistage centrifugal pump.',
    description: 'High-quality vertical and horizontal multistage centrifugal pumps for industrial water treatment and supply.',
    features: ['Vertical and Horizontal models', 'High efficiency', 'Non-self priming'],
    applications: ['Water supply', 'Industrial processing', 'Water treatment']
  },
  {
    id: 'pressure-gauge',
    name: 'Pressure Gauge',
    category: 'Other Filter Spare Parts',
    image: 'https://cdn1.sharemyimage.com/smi/2026/01/10/57bac2ad6eee7941bee4cac472a7f637.jpg',
    shortDescription: 'Shock-resistant liquid-filled and dry pressure gauges for precise positive and negative pressure measurement.',
    description: 'Available in liquid-filled and dry types with customizable ranges (0-15 to 0-8500 Psi) and durable construction.',
    features: ['Liquid-filled & dry types', 'Shock resistant', 'Wide measurement range', 'Customizable'],
    applications: ['Industrial machinery', 'Hydraulic systems', 'Water treatment']
  },
  {
    id: 'pressure-controller',
    name: 'Pressure Controller',
    category: 'Other Filter Spare Parts',
    image: 'https://cdn1.sharemyimage.com/smi/2026/01/10/46ecd9034d42c20e0f767555b09d315d.jpg',
    shortDescription: 'Reliable pressure switches for low and high pressure control in water treatment systems.',
    description: 'Pressure controllers designed to protect pumps and systems by monitoring and controlling low and high pressure conditions.',
    features: ['Low & High Pressure models', 'Adjustable range', 'Automatic reset', 'Durable construction'],
    applications: ['RO systems', 'Booster pumps', 'Water supply control']
  },
  {
    id: 'portable-sdi-fi-pollution-index-apparatus',
    name: 'Portable SDI(FI) Pollution Index Apparatus',
    category: 'Other Filter Spare Parts',
    image: 'https://cdn1.sharemyimage.com/smi/2026/01/10/8858340123a5927d97d49907c465e36a.jpg',
    shortDescription: 'Portable apparatus for determining Silt Density Index (SDI) / Fouling Index (FI) of water, essential for RO system monitoring.',
    description: 'Portable apparatus for determining Silt Density Index (SDI) / Fouling Index (FI) of water, essential for RO system monitoring.',
    features: ['Measures Fouling Index (FI) / SDI value', 'Includes pressure regulating valve and filter box', 'Uses φ47mm, 0.45μm microfiltration membrane', 'Crucial for protecting RO membranes'],
    applications: ['Reverse Osmosis (RO) system inlet monitoring', 'Water quality analysis', 'Water treatment process evaluation']
  },
  {
    id: 'conductivity-meter',
    name: 'Conductivity Meter',
    category: 'Other Filter Spare Parts',
    image: 'https://cdn1.sharemyimage.com/smi/2026/01/10/63a7b97576951bd88c2658470d38ea9d.png',
    shortDescription: 'Model: CCT-3320V (CM230). Reliable inline conductivity monitor for water quality measurement.',
    description: 'Model CCT-3320V (CM230) is a widely used conductivity monitor for water treatment systems, featuring automatic range shift and digital temperature compensation.',
    features: ['No adjustable internal components', 'Automatic range shift', 'Digital temperature compensation', '1.5% accuracy'],
    applications: ['Reverse Osmosis (RO) systems', 'Pure water production', 'Cooling water monitoring', 'Industrial water treatment']
  }
];

export default otherSparePartsProducts;